export default __webpack_public_path__ + "static/media/pavel_m.c4305efe.jpg";